(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-vendors"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.currentScript && document.currentScript.parentElement || document;
  var input = root.querySelector('.brands-index__search-input');
  if(!input) return;
  input.addEventListener('input', function(){
    var q = (this.value||'').toLowerCase();
    root.querySelectorAll('.brands-index__item').forEach(function(li){
      var name = (li.getAttribute('data-brand')||'').toLowerCase();
      li.style.display = name.indexOf(q) > -1 ? '' : 'none';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('hb-product-tabs')) {
    customElements.define(
      'hb-product-tabs',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.loaded = new Set();

          this.buttons = [
            ...this.querySelectorAll('[data-hb-tab]')
          ];

          this.buttons.forEach((button, index) => {
            button.addEventListener('click', () => {
              this.activate(button.dataset.hbTab);
            });

            button.addEventListener('keydown', (event) => {
              let next = index;

              if (event.key === 'ArrowRight') {
                next = (index + 1) % this.buttons.length;
              } else if (event.key === 'ArrowLeft') {
                next = (
                  index - 1 + this.buttons.length
                ) % this.buttons.length;
              } else if (event.key === 'Home') {
                next = 0;
              } else if (event.key === 'End') {
                next = this.buttons.length - 1;
              } else {
                return;
              }

              event.preventDefault();
              this.buttons[next].focus();

              this.activate(
                this.buttons[next].dataset.hbTab
              );
            });
          });

          this.activate('brand');
        }

        activate(name) {
          this.buttons.forEach((button) => {
            const active = button.dataset.hbTab === name;

            button.setAttribute(
              'aria-selected',
              String(active)
            );

            button.tabIndex = active ? 0 : -1;
          });

          this.querySelectorAll(
            '[data-hb-panel]'
          ).forEach((panel) => {
            panel.hidden = panel.dataset.hbPanel !== name;
          });

          this.load(name);
          window.dispatchEvent(new Event('resize'));
        }

        async load(name) {
          if (this.loaded.has(name)) return;
          this.loaded.add(name);

          const panel = this.querySelector(
            `[data-hb-panel="${name}"]`
          );

          const grid = panel.querySelector('[data-hb-grid]');
          const status = panel.querySelector('[data-hb-status]');

          try {
            let url;

            if (name === 'related') {
              url = new URL(
                this.dataset.relatedUrl,
                window.location.origin
              );
            } else {
              const root = this.dataset.root.replace(
                /\/?$/,
                '/'
              );

              url = new URL(
                root + 'collections/vendors',
                window.location.origin
              );

              url.searchParams.set(
                'q',
                this.dataset.vendor
              );

              url.searchParams.set(
                'section_id',
                'hb-brand-products'
              );
            }

            const previewThemeId = new URL(
              window.location.href
            ).searchParams.get('preview_theme_id');

            if (previewThemeId) {
              url.searchParams.set(
                'preview_theme_id',
                previewThemeId
              );
            }

            const response = await fetch(url);

            if (!response.ok) {
              throw new Error('Producten ophalen mislukt');
            }

            const html = new DOMParser().parseFromString(
              await response.text(),
              'text/html'
            );

            const source = name === 'related'
              ? html.querySelector(
                  'template[data-hb-related-results]'
                )?.content
              : html.querySelector(
                  '[data-hb-brand-results]'
                );

            if (!source) {
              throw new Error('Productbron ontbreekt');
            }

            const cards = [
              ...source.querySelectorAll(
                '[data-hb-brand-card]'
              )
            ];

            const seen = new Set();
            const fragment = document.createDocumentFragment();
            const limit = Number(this.dataset.limit) || 4;

            let count = 0;

            for (const card of cards) {
              const id = card.dataset.productId;

              if (
                id === this.dataset.productId ||
                seen.has(id)
              ) {
                continue;
              }

              if (
                this.dataset.allowSale !== 'true' &&
                card.dataset.onSale === 'true'
              ) {
                continue;
              }

              if (
                name === 'brand' &&
                card.dataset.vendor !== this.dataset.vendor
              ) {
                continue;
              }

              const productCard = card.firstElementChild;

              if (!productCard) continue;

              seen.add(id);

              fragment.appendChild(
                productCard.cloneNode(true)
              );

              count++;

              if (count >= limit) break;
            }

            grid.replaceChildren(fragment);

            status.textContent = count
              ? ''
              : 'Er zijn momenteel geen passende artikelen beschikbaar.';

            status.hidden = count > 0;
            grid.hidden = count === 0;

            if (
              count &&
              window.theme?.reinitProductGridItem
            ) {
              window.theme.reinitProductGridItem(panel);
            }

            if (window.AOS) {
              window.AOS.refreshHard();
            }
          } catch (error) {
            status.hidden = false;
            grid.hidden = true;

            status.textContent =
              'De artikelen konden niet worden geladen.';

            this.loaded.delete(name);
            console.error(error);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
